export default __webpack_public_path__ + "static/media/css.d187f8a9.png";